import React, { useMemo } from 'react';
import './index.scss';
import MetricsCardWrap from '../../components/MetricsCardWrap';
import MetricsCardValue, { IMetricsCardValue } from '../../components/MetricsCardValue';
import MetricsCardDod, { IMetricsDod } from '../../components/MetricsCardDod';
import MetricsCardSubTitle from './MetricsCardSubTitle';

interface IMetricsCardWrap {
  // 类名
  className?: string;
  // 样式
  style?: React.CSSProperties;
  // 中英文标题
  titleEn: string;
  titleCn: string;
  // 中英文副标题
  subtitleEn?: string;
  subtitleCn?: string;
  // 跳转链接
  link?: string;
  // 标题旁图标
  icon?: string;
  // 标题旁图片地址
  imgUrl?: string;
  // 是否开启icon的info提示（与标题hover的提示互斥）
  isIconTips?: boolean;
  // 中英文指标注释
  tipsEn?: string;
  tipsCn?: string;
  // 头部组件
  contentHeader?: JSX.Element;
  // 尾部组件
  contentFooter?: JSX.Element;
}

interface IMetricsCardSubTitle {
  // 类名
  className?: string;
  // 样式
  style?: React.CSSProperties;
  titleEn: string;
  titleCn: string;
  tipsEn?: string;
  tipsCn?: string;
}

interface IMetricsCardDod {
  // 类名
  dodClassName?: string;
  // 样式
  dodStyle?: React.CSSProperties;

  dodData: IMetricsDod[];
}

interface IMetricsCardItem extends IMetricsCardValue, IMetricsCardDod, IMetricsCardSubTitle {
  valueStyle?: React.CSSProperties;
  valueClassName?: string;
}

interface IMetricsCardMulti extends IMetricsCardWrap, IMetricsCardValue, IMetricsCardDod {
  metricsCardItem: IMetricsCardItem[];
  valueStyle?: React.CSSProperties;
  metricsChart?: JSX.Element;
  valueClassName?: string;
}


const MetricsCardMulti = (props: IMetricsCardMulti) => {

  const { titleEn, titleCn, subtitleEn, subtitleCn, icon, imgUrl, link, tipsEn, tipsCn, isIconTips, contentHeader, valueClassName, valueStyle, value, formatRule, emptyValue, preUnit, endUnit, dodClassName, dodStyle, dodData, metricsChart, metricsCardItem, style, className } = props;

  const contentFooter = useMemo(() => (
    <div className={`dbd-metrics-card-multi__row margin-t-30`}>
      {
        metricsCardItem?.map((val, ind: number) => {
          const { className, style, titleEn, titleCn, tipsEn, tipsCn, valueClassName, valueStyle, value, formatRule, emptyValue, preUnit, endUnit, dodClassName, dodStyle, dodData } = val;

          return (
            <div key={ind} className={`dbd-metrics-card-multi__flex`}>
              <MetricsCardSubTitle
                titleEn={titleEn}
                titleCn={titleCn}
                tipsEn={tipsEn}
                tipsCn={tipsCn}
                className={className}
                style={style}
              />
              <MetricsCardValue
                className={valueClassName}
                style={valueStyle}
                value={value}
                formatRule={formatRule}
                emptyValue={emptyValue}
                preUnit={preUnit}
                endUnit={endUnit}
              />
              <MetricsCardDod
                className={dodClassName}
                style={dodStyle}
                data={dodData}
              />
            </div>
          );
        })
      }
    </div>
  ), [metricsCardItem]);


  return (
    <MetricsCardWrap
      titleCn={titleCn}
      titleEn={titleEn}
      className={className}
      style={style}
      link={link}
      tipsEn={tipsEn}
      tipsCn={tipsCn}
      icon={icon}
      imgUrl={imgUrl}
      isIconTips={isIconTips}
      subtitleEn={subtitleEn}
      subtitleCn={subtitleCn}
      contentHeader={contentHeader}
      contentFooter={contentFooter}
    >
      <div className={`dbd-metrics-card__flex dbd-metrics-card__row`}>
        <div className={`dbd-metrics-card__flex`}>
          <MetricsCardValue
            className={valueClassName}
            style={valueStyle}
            value={value}
            formatRule={formatRule}
            emptyValue={emptyValue}
            preUnit={preUnit}
            endUnit={endUnit}
          />
          <MetricsCardDod
            className={dodClassName}
            style={dodStyle}
            data={dodData}
          />
        </div>
        {
          metricsChart && metricsChart
        }
      </div>
    </MetricsCardWrap>
  );
};

export default MetricsCardMulti;